if (!customElements.get('nuer-sale-strip')) {
  customElements.define('nuer-sale-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-ready')) return;
      const button = this.querySelector('.nuer-sale-strip__toggle');
      const viewport = this.querySelector('.nuer-sale-strip__viewport');
      const groups = [...this.querySelectorAll('.nuer-sale-strip__group')];
      if (!button || !viewport || groups.length !== 2) return;

      const originals = [...groups[0].children].map((node) => node.cloneNode(true));
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const fill = () => {
        groups.forEach((group) => {
          group.querySelectorAll(':scope > [data-sale-repeat]').forEach((node) => node.remove());
        });
        if (motion.matches) return;

        const viewportWidth = viewport.getBoundingClientRect().width;
        const groupWidth = groups[0].getBoundingClientRect().width;
        if (!viewportWidth || !groupWidth) return;
        const copies = Math.max(1, Math.ceil((viewportWidth + 1) / groupWidth));

        groups.forEach((group) => {
          const fragment = document.createDocumentFragment();
          for (let copy = 1; copy < copies; copy += 1) {
            originals.forEach((original) => {
              const clone = original.cloneNode(true);
              clone.setAttribute('aria-hidden', 'true');
              clone.setAttribute('inert', '');
              clone.setAttribute('data-sale-repeat', '');
              fragment.appendChild(clone);
            });
          }
          group.appendChild(fragment);
        });
      };
      const scheduleFill = () => {
        cancelAnimationFrame(this.saleStripFrame);
        this.saleStripFrame = requestAnimationFrame(fill);
      };

      this.saleStripToggle = () => {
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Resume sale strip' : 'Pause sale strip');
      };
      button.addEventListener('click', this.saleStripToggle);
      this.saleStripSchedule = scheduleFill;
      this.saleStripMotion = motion;
      motion.addEventListener('change', scheduleFill);
      if (window.ResizeObserver) {
        this.saleStripObserver = new ResizeObserver(scheduleFill);
        this.saleStripObserver.observe(viewport);
      } else {
        window.addEventListener('resize', scheduleFill);
      }
      button.hidden = false;
      this.setAttribute('data-ready', '');
      fill();
      document.fonts?.ready.then(() => {
        if (this.isConnected && this.saleStripSchedule === scheduleFill) scheduleFill();
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.saleStripFrame);
      this.saleStripObserver?.disconnect();
      window.removeEventListener('resize', this.saleStripSchedule);
      this.saleStripMotion?.removeEventListener('change', this.saleStripSchedule);
      const button = this.querySelector('.nuer-sale-strip__toggle');
      button?.removeEventListener('click', this.saleStripToggle);
      if (button) button.hidden = true;
      this.querySelectorAll('[data-sale-repeat]').forEach((node) => node.remove());
      this.removeAttribute('data-ready');
    }
  });
}
